module.exports = __webpack_public_path__ + "img/notRegistered.c8c80cad.svg";